module.exports = __webpack_public_path__ + "img/V72.33aa6c7d.jpg";